<!--
 * @Description  : 选择关联文库弹框
 * @Author       : zcc
 * @Date         : 2025-04-25 16:59:09
 * @LastEditors  : zcc
 * @LastEditTime : 2025-05-06 10:28:11
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\library\library-type-management\components\choose-relate-dialog.vue
-->
<template>
  <el-dialog
    :title="dialogObj.title"
    :visible.sync="dialogObj.visible"
    :width="dialogObj.width"
    :close-on-click-modal="false"
    @close="closeDialog"
    append-to-body
  >
    <template v-if="dialogObj.visible">
      <el-form
        ref="searchForm"
        class="table-form"
        :model="searchForm"
        label-width="100px"
      >
        <el-row noSpace>
          <el-col :span="6">
            <el-form-item label="标题" prop="title">
              <el-input
                v-model="searchForm.title"
                placeholder="请输入"
                class="w100"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="文号" prop="referNo">
              <el-input
                v-model="searchForm.referNo"
                placeholder="请输入"
                class="w100"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="颁布机关" prop="issueUnit">
              <el-input
                v-model="searchForm.issueUnit"
                placeholder="请输入"
                class="w100"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="2">
            <el-button
              type="text"
              class="ml10"
              @click="showMoreSearch = !showMoreSearch"
            >
              {{ showMoreSearch ? "收起" : "更多" }}
              <svg-icon
                :icon-class="showMoreSearch ? 'pack-up' : 'pack-down'"
                class="ml5"
              ></svg-icon>
            </el-button>
          </el-col>
          <el-col :span="4" class="text-right">
            <el-button type="primary" plain @click="resetSearch">
              重置
            </el-button>
            <el-button type="primary" class="ml10" @click="search">
              查询
            </el-button>
          </el-col>
        </el-row>

        <el-row noSpace v-if="showMoreSearch">
          <el-col :span="6">
            <el-form-item label="时效性" prop="efficient">
              <el-select
                v-model="searchForm.efficient"
                clearable
                multiple
                collapse-tags
                filterable
              >
                <el-option
                  :label="item.sname"
                  :value="item.value"
                  v-for="item in projectDict.zsksxx"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="施行日期" prop="dateArr">
              <el-date-picker
                v-model="searchForm.dateArr"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="所属分类" prop="type">
              <el-cascader
                class="w100 sp-cascader"
                clearable
                v-model="searchForm.type"
                multiple
                placeholder="请选择"
                :options="typeDict"
                :props="{
                  expandTrigger: 'hover',
                  label: 'sname',
                  multiple: true,
                  value: 'id',
                  emitPath: false
                }"
                collapse-tags
                separator=">"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 下方表格内容 -->
      <vxe-grid ref="xGrid" v-bind="gridOptions">
        <template #toolbar_buttons> </template>
        <template #toolbar_tools>
          <el-button type="primary" plain @click="doExport">导出</el-button>
        </template>

        <!-- 公示日期 -->
        <template #releaseDate_header>
          <div class="sort_class">
            <span class="padding_right20">公示日期</span>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_shengxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 1 && searchForm.fieldType == '0'
              }"
              @click="getSort('0', '1')"
            ></svg-icon>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_jiangxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 0 && searchForm.fieldType == '0'
              }"
              @click="getSort('0', '0')"
            ></svg-icon>
          </div>
        </template>

        <!-- 施行日期 -->
        <template #applyDate_header>
          <div class="sort_class">
            <span class="padding_right20">施行日期</span>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_shengxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 1 && searchForm.fieldType == '1'
              }"
              @click="getSort('1', '1')"
            ></svg-icon>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_jiangxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 0 && searchForm.fieldType == '1'
              }"
              @click="getSort('1', '0')"
            ></svg-icon>
          </div>
        </template>

        <!-- 创建日期 -->
        <template #createDate_header>
          <div class="sort_class">
            <span class="padding_right20">创建日期</span>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_shengxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 1 && searchForm.fieldType == '2'
              }"
              @click="getSort('2', '1')"
            ></svg-icon>
            <svg-icon
              icon-class="sanjiao_fill"
              class="ml5 sort_icon sort_jiangxu"
              :class="{
                sort_bg:
                  searchForm.fieldSort == 0 && searchForm.fieldType == '2'
              }"
              @click="getSort('2', '0')"
            ></svg-icon>
          </div>
        </template>
      </vxe-grid>

      <div class="table-footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageList"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          v-if="showPage || total > 0"
        >
        </el-pagination>
      </div>
    </template>

    <!-- 底部按钮 -->
    <template #footer>
      <el-button @click="closeDialog"> 取 消 </el-button>
      <el-button type="primary" :loading="btnLoading" @click="handleSave">
        确 定
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
// js
import { mapState, mapGetters } from "vuex";
import { exportPlus } from "utils/tools";
import XEUtils from "xe-utils";
import * as typeApi from "api/modules/library/library-type-management/index.js";
export default {
  components: {},
  data() {
    return {
      dialogObj: {
        visible: false,
        title: "关联文档",
        width: "1200px",
        mode: "add"
      },
      searchForm: {
        title: "", // 标题
        referNo: "", // 文号
        issueUnit: "", // 颁布机关
        efficient: [], // 时效性
        dateArr: "", //  实行日期
        applyStartDate: "", // 实行日期（起）
        applyEndDate: "", // 实行日期（止）
        type: [], // 所属分类
        fieldType: "", // 排序字段
        fieldSort: "", // 排序类型（0降序，1升序)
        isBind: "0" // 展示已关联的文库
      },
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      showPage: false,
      loading: false,

      // 静态列配置
      showMoreSearch: false, // 搜索 展开

      // 表格配置
      gridOptions: {
        // 开启溢出隐藏
        showOverflow: true,
        showHeaderOverflow: true,
        autoResize: true,
        border: true,
        data: [], // 表格数据
        scrollY: {
          enabled: true, //滚动模式
          gt: 10 //指定大于行数就滚动
        },
        // 工具栏配置
        toolbarConfig: {
          custom: false,
          slots: {
            tools: "toolbar_tools",
            buttons: "toolbar_buttons"
          }
        },
        // 列配置
        columnConfig: {
          resizable: true
        },
        editConfig: {
          trigger: "click",
          mode: "cell",
          enabled: false
          // enabled: isEdit
        },
        tooltipConfig: {
          showAll: true,
          zIndex: 9999
        },
        treeConfig: {
          childrenField: "children",
          expandAll: true,
          parentField: "pid",
          indent: 10,
          transform: false,
          rowField: "id",
          iconOpen: "vxe-icon-folder-open",
          iconClose: "vxe-icon-folder"
        },
        columns: [],
        rowConfig: {
          keyField: "id",
          isHover: true,
          isCurrent: true
        },
        height: "400px",
        checkboxConfig: { checkMethod: this.checkRelateMethod }
      },
      typeRow: {}, // 文库类型
      typeDict: [], // 所属分类数组
      btnLoading: false, // 按钮加载中
      aliasName: "chooseRelate"
    };
  },
  created() {},
  mounted() {},
  methods: {
    /********************   弹框打开与关闭   ********************/
    // 弹框初始化
    initDialog(data) {
      //  弹窗打开
      this.dialogObj.visible = true;

      // 文库赋值
      this.typeRow = data;

      // 将搜索条件收起
      this.showMoreSearch = false;

      // 重置表单
      this.searchForm = {
        title: "", // 标题
        referNo: "", // 文号
        issueUnit: "", // 颁布机关
        efficient: [], // 时效性
        dateArr: "", //  实行日期
        applyStartDate: "", // 实行日期（起）
        applyEndDate: "", // 实行日期（止）
        type: [], // 所属分类
        fieldType: "", // 排序字段
        fieldSort: "", // 排序类型（0降序，1升序)
        isBind: "0" // 展示已关联的文库
      };

      // 获取静态列配置
      this.getStaticColumns();
    },

    // 关闭弹窗
    closeDialog() {
      //  关闭弹窗
      this.dialogObj.visible = false;
      this.currentPage = 1; // 返回第一页
      this.$emit("updateSearch");
      setTimeout(() => {
        this.btnLoading = false;
      }, 1000);
    },

    /********************   表格相关操作   ********************/

    //  静态数组（全列头）
    getStaticColumns() {
      this.gridOptions.columns = XEUtils.clone(this.staticColumns, true);
      this.$nextTick(() => {
        this.$refs.xGrid && this.$refs.xGrid.refreshColumn();
        this.chooseData();
      });
    },

    // 异步抓取数据
    chooseData(obj) {
      this.loading = true;
      let params = { ...JSON.parse(JSON.stringify(this.searchForm)) };
      // 时间段数据处理
      params.applyStartDate =
        params.dateArr && params.dateArr.length > 0 ? params.dateArr[0] : "";
      params.applyEndDate =
        params.dateArr && params.dateArr.length > 0 ? params.dateArr[1] : "";
      // 删除时间段
      delete params.dateArr;
      // 文库类型id
      params.typeId = this.typeRow.id;
      params.current = this.currentPage;
      params.size = this.pageSize;

      this.gridOptions.data = [];
      this.total = 0;

      typeApi
        .selectDocManage(params)
        .then(res => {
          if (res.code == 0) {
            // 所属分类数组赋值
            this.typeDict = res.data.docTypeTree;
            // 选中已关联的文档
            setTimeout(() => {
              res.data.docManagePage.records.map(x => {
                if (x.isChoose == 1) {
                  this.$refs.xGrid.setCheckboxRow(x, true);
                }
              });
            }, 200);

            this.gridOptions.data = res.data.docManagePage.records;
            this.total = Number(res.data.docManagePage.total);
            this.showPage = Number(res.data.docManagePage.total) === 0;
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.chooseData();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.chooseData();
    },

    // 导出
    doExport() {
      let search = JSON.parse(JSON.stringify(this.searchForm));
      const params = {
        ...search,
        columns: this.gridOptions.columns.filter(
          i => !!i.visible && !["checkbox"].includes(i.field)
        )
      };
      params.columns[0].field = "index";
      // 文库类型id
      params.typeId = this.typeRow.id;
      exportPlus("/docType/exportDocManage", params);
    },

    /********************   搜索表单处理   ********************/

    // 处理排序
    getSort(type, status) {
      // 排序赋值
      this.searchForm.fieldType = type;
      this.searchForm.fieldSort = status;

      // 获取列表数据
      this.search();
    },

    // 选择日期change
    onChangeDate(arr) {
      this.searchForm.planStart = arr ? arr[0] : "";
      this.searchForm.planEnd = arr ? arr[1] : "";
    },

    // 搜索
    search() {
      this.chooseData();
    },

    // 重置
    resetSearch() {
      // 重置表单
      this.searchForm = {
        title: "", // 标题
        referNo: "", // 文号
        issueUnit: "", // 颁布机关
        efficient: [], // 时效性
        dateArr: "", //  实行日期
        applyStartDate: "", // 实行日期（起）
        applyEndDate: "", // 实行日期（止）
        type: [], // 所属分类
        fieldType: "", // 排序字段
        fieldSort: "", // 排序类型（0降序，1升序)
        isBind: "0" // 展示已关联的文库
      };
      this.chooseData();
    },

    // 保存
    handleSave() {
      let arr = this.$refs.xGrid.getCheckboxRecords();
      let newArr = arr.filter(item => item.isChoose != 1);

      if (newArr.length == 0) {
        this.$message.warning({ message: "必须选择一条文档!" });
        return;
      }

      let params = {
        manageIds: newArr.map(item => item.id),
        typeId: this.typeRow.id
      };

      typeApi.relateDocManage(params).then(res => {
        this.$message.success({ message: "保存成功!" });
        // 关闭弹框
        this.closeDialog();
      });
    },

    // 不允许勾选
    checkRelateMethod({ row }) {
      // isChoose 为1时不允许勾选
      return row.isChoose != 1;
    }
  },
  computed: {
    ...mapState("tabs", {
      currentTab: state => state.currentTab
    }),
    ...mapState("menu", {
      userInfo: state => state.userInfo,
      roleBtns: state => state.roleBtns
    }),
    ...mapState("dict", {
      projectDict: state => state.projectDict //项目字典
    }),

    ...mapGetters("dict", ["curDescriple", "descripleContent"]),

    // 静态列
    staticColumns() {
      return [
        {
          field: "checkbox",
          type: "checkbox",
          title: "",
          width: 60,
          minWidth: "",
          align: "center",
          headerAlign: "center",
          visible: true,
          forbidCheck: 1,
          forbidDrag: 1
        },

        {
          type: "seq",
          title: "序号",
          width: 70,
          align: "left",
          headerAlign: "left",
          visible: true,
          forbidCheck: 1,
          forbidDrag: 1
        },

        {
          field: "title",
          title: "标题",

          minWidth: 220,
          align: "left",
          headerAlign: "left",
          visible: true,
          forbidCheck: 1,
          forbidDrag: 1
        },

        {
          field: "issueUnit",
          title: "颁布机关",
          minWidth: 100,
          visible: true
        },
        {
          field: "referNo",
          title: "文号",
          minWidth: 100,
          visible: true
        },
        {
          field: "efficientName",
          title: "时效性",
          minWidth: 100,
          visible: true
        },
        {
          field: "releaseDate",
          title: "公示日期",
          minWidth: 100,
          visible: true,
          slots: { header: "releaseDate_header" }
        },

        {
          field: "applyDate",
          title: "施行日期",
          minWidth: 100,
          visible: true,
          slots: { header: "applyDate_header" }
        },

        {
          field: "createUser",
          title: "创建人",
          minWidth: 100,
          visible: true
        },
        {
          field: "createDate",
          title: "创建日期",
          minWidth: 100,
          visible: true,
          slots: { header: "createDate_header" }
        }
      ];
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
/deep/.el-dialog-box .el-dialog-box__body {
  max-height: 700px !important;
  overflow: scroll;
  overflow-x: hidden;
}
.w100 {
  width: 100% !important;
}
.sp-cascader {
  /deep/.el-input__inner {
    height: 36px !important;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.more {
  min-width: 50px;
  color: #3ba1ff;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  margin-top: 8px;
  padding-left: 20px;

  .icon-more {
    width: 14px;
    height: 14px;
  }
}

.sort_class {
  position: relative;
  .padding_right20 {
    padding-right: 20px;
  }
  .sort_icon {
    position: absolute;
    top: 0;
    right: 5px;
    width: 0.7em !important;
    height: 0.9em !important;
    color: #c0c4cc;
    cursor: pointer;
  }
  .sort_jiangxu {
    top: 12px !important;
    transform: rotate(180deg);
  }
  .sort_bg {
    color: #3ba1ff;
  }
}

// 图标
.font-size40 {
  font-size: 35px;
}
.vertical-align {
  vertical-align: -13px;
}

.red {
  color: red;
}

/deep/.table-form .el-select .el-tag {
  max-width: 70px;
}

/deep/.table-form .el-cascader .el-tag {
  max-width: 70px;
}

/deep/ .vxe-table--render-default.vxe-editable .vxe-body--column {
  height: 40px;
}

.table-footer {
  display: flex;
  align-items: center;
  justify-self: center;
  margin-top: 10px;
}
</style>
